import request from '@/utils/request'

/**
 * 获取优惠券池列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listCouponPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/couponPool.listCouponPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 生成支付二维码
 * @param {Object} data 请求数据
 * @returns {Promise} Promise对象
 */
export function toQrPayGold(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/paymentGold/toQrPayGold',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}